export function createAdvancedQuery(_ref, maxLength) {
  let userQuery = _ref.query,
    keywords = _ref.keywords,
    style = _ref.style;
  if (maxLength === void 0) {
    maxLength = 100;
  }
  const queries = [];
  if (userQuery) {
    const smartQuery = keywords != null && keywords.length || style ? `Query: ${userQuery}` : userQuery;
    queries.push(smartQuery);
  }
  if (keywords != null && keywords.length) {
    queries.push(`Include the following keywords: ${keywords == null ? void 0 : keywords.join(', ')}`);
  }
  if (style) {
    queries.push(`Answer in a ${style} style`);
  }
  return queries.reduce((result, query) => {
    const newResult = result ? `${result}. ${query}` : query;
    return newResult.length <= maxLength ? newResult : result;
  }, '');
}
//# sourceMappingURL=useRecommendations.utils.js.map